<template>
  <div style="position: relative">
    <v-card flat>
      <v-container fluid class="grey lighten-4" pa-0>
        <v-row no-gutters style="container-data-filter-buttons">
          <v-col class="align-self-center" md="auto" xs="auto" sm="auto">
            <!-- Back button -->
            <crud-button
              x-large
              color="blue-grey darken-1"
              @clicked="back()"
              icon="fa-chevron-left"
              :tooltip="$t('global.crud.buttons.return')"
            />
          </v-col>
          <v-col
            cols="1"
            class="flex-grow-1 flex-shrink-0 container-data-filter-info"
          >
            <v-container fluid pa-0>
              <v-row>
                <v-col sm="12" cols="12">
                  <div class="form-field-name">
                    {{ $t("productsTypesTranslations.productType") }}
                  </div>
                  <div class="form-field-value">
                    {{ productType }}
                  </div>
                </v-col>
              </v-row>
            </v-container></v-col
          >
        </v-row>
      </v-container>
      <div id="controlsContainer">
        <div
          class="card-title table-controls px-3 d-flex align-center justify-space-between"
        >
          <div>
            <!-- CRUD buttons -->
            <!-- dialog for creating item -->
            <crud-button
              x-large
              color="light-blue lighten-2"
              @clicked="create()"
              icon="fa-plus"
              :tooltip="$t('global.crud.button.add')"
            />
          </div>
          <!-- center side -->
          <div>
            <!-- Search by fields -->
          </div>
          <!-- right side -->
          <div>
            <!-- Refresh table -->
            <crud-button
              large
              color="blue"
              @clicked="refreshItemsView()"
              icon="fa-sync-alt"
              :tooltip="$t('global.crud.buttons.refreshTable')"
            />
            <ExportExcel
              url="/productsTypesTranslations"
              :filter="this.filter"
            />
            <ImportExcel url="/productsTypesTranslations" @done="search" />
          </div>
        </div>
      </div>
      <div id="dataContainer">
        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :page.sync="pagination.page"
          :server-items-length="pagination.totalItems"
          :no-results-text="$t('global.datatable.noMatchingResults')"
          :no-data-text="$t('global.datatable.noDataAvailable')"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
            'show-first-last-page': true,
            'show-current-page': true
          }"
          :loading="loading"
          light
          multi-sort
          dense
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.code">
                <td>
                  <!-- Edit record -->
                  <crud-button
                    x-small
                    color="orange"
                    icon="fa-pen"
                    :tooltip="$t('global.crud.buttons.edit')"
                    @clicked="
                      edit(item.languageCode + '/' + item.productTypeCode)
                    "
                  ></crud-button>

                  <!-- Delete record -->
                  <crud-button
                    v-if="
                      item.deletionDate === undefined ||
                        item.deletionDate === null
                    "
                    x-small
                    color="red"
                    icon="fa-trash"
                    :tooltip="$t('global.crud.buttons.delete')"
                    @clicked="
                      suspend(item.languageCode + '/' + item.productTypeCode)
                    "
                  ></crud-button>
                </td>
                <td>{{ item.productTypeCode }}</td>
                <td>{{ item.languageCode }}</td>
                <td>{{ item.translatedName }}</td>
                <td>{{ item.translatedDescription }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="600" persistent no-click-animation>
      <validation-observer ref="obs" v-slot="{ invalid, validated, passes }">
        <v-card>
          <v-toolbar dark color="primary" dense flat>
            <v-toolbar-title class="white--text">
              {{ formTitle }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="details-list">
            <v-form>
              <v-layout row wrap>
                <v-flex class="sm12">
                  <v-text-field
                    :label="$t('productsTypesTranslations.productType')"
                    v-model="productType"
                    disabled
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="sm12">
                  <validation-provider
                    v-if="!editMode"
                    :name="$t('productsTypesTranslations.language')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-autocomplete
                      v-model="item.languageCode"
                      :items="languagesItems"
                      :loading="languages.isLoading"
                      :search-input.sync="languages.search"
                      hide-no-data
                      :no-data-text="$t('global.autocomplete.noDataFound')"
                      item-text="description"
                      item-value="code"
                      :label="$t('productsTypesTranslations.language')"
                      :placeholder="
                        $t('global.autocomplete.starTypingToSearch')
                      "
                      @focus="languages.isEdit = true"
                      @change="languages.isEdit = false"
                      :error-messages="errors"
                      clearable
                    ></v-autocomplete>
                  </validation-provider>
                  <v-text-field
                    v-else
                    :label="$t('productsTypesTranslations.language')"
                    v-model="item.languageCode"
                    disabled
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="sm12">
                  <validation-provider
                    :name="$t('productsTypesTranslations.translationName')"
                    rules="required|max:30"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="$t('productsTypesTranslations.translationName')"
                      v-model="item.translatedName"
                      required
                      :error-messages="errors"
                      counter="30"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex class="sm12">
                  <validation-provider
                    :name="
                      $t('productsTypesTranslations.translationDescription')
                    "
                    rules="required|max:255"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :label="
                        $t('productsTypesTranslations.translationDescription')
                      "
                      v-model="item.translatedDescription"
                      required
                      :error-messages="errors"
                      counter="255"
                    ></v-text-field>
                  </validation-provider>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click.native="close()">
              {{ $t("global.buttons.close") }}
            </v-btn>
            <v-btn v-if="editMode" color="orange" text @click="passes(update)">
              {{ $t("global.buttons.update") }}
            </v-btn>
            <v-btn v-else color="green" text @click="passes(save)">
              {{ $t("global.buttons.create") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<script>
import CrudButton from "@/components/Button.vue";
import localhttp from "../js/https-commons";
import ExportExcel from "@/components/ExportExcel.vue";
import ImportExcel from "@/components/ImportExcel.vue";

const CONTEXT = "/productsTypesTranslations";
const CONTEXT_PRODUCTS_TYPES = "/productsTypes";
const ENTITY_NAME = "productTypeTranslation.";
const CONTEXT_LANGUAGES = "/languages";

export default {
  props: {
    productType: {
      type: String,
      required: true
    }
  },
  components: {
    CrudButton,
    ExportExcel,
    ImportExcel
  },
  name: "ProductsTypesTranslations",
  data: () => ({
    loading: false,
    searchTableWaiting: false,
    editMode: false,
    dialog: false,
    item: {},
    items: [],
    filter: {
      allFields: "",
      productType: ""
    },
    options: {},
    pagination: {
      totalItems: 0,
      page: 1
    },
    rowsPerPageItems: [10, 20, 30, 40],
    productsTypes: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    },
    languages: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    },
    productsTypesFilter: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    }
  }),
  computed: {
    formTitle() {
      return this.editMode
        ? this.$t("productsTypesTranslations.title.edit")
        : this.$t("productsTypesTranslations.title.new");
    },
    headers() {
      return [
        {
          text: this.$t("global.datatable.header.actions"),
          value: "actions",
          sortable: false
        },
        {
          text: this.$t("productsTypesTranslations.datatable.productType"),
          value: ENTITY_NAME + "productTypeCode"
        },
        {
          text: this.$t("productsTypesTranslations.datatable.language"),
          value: ENTITY_NAME + "languageCode"
        },
        {
          text: this.$t("productsTypesTranslations.translationName"),
          value: ENTITY_NAME + "translatedName"
        },
        {
          text: this.$t("productsTypesTranslations.translationDescription"),
          value: ENTITY_NAME + "translatedDescription"
        }
      ];
    },
    productsTypesItems() {
      return this.productsTypes.entries.map(entry => {
        const description = entry.code + " - " + entry.description;
        return Object.assign({}, entry, { description });
      });
    },
    languagesItems() {
      return this.languages.entries.map(entry => {
        const description = entry.code + " - " + entry.name;
        return Object.assign({}, entry, { description });
      });
    },
    productsTypesFilterItems() {
      return this.productsTypesFilter.entries.map(entry => {
        const description = entry.code + " - " + entry.description;
        return Object.assign({}, entry, { description });
      });
    }
  },
  watch: {
    options: {
      handler() {
        this.search();
      },
      deep: true
    },
    "pagination.totalItems": {
      handler() {
        this.pagination.page = 1;
      },
      deep: true
    },
    "filter.allFields": function() {
      if (!this.searchTableWaiting) {
        setTimeout(() => {
          this.search();
          this.searchTableWaiting = false;
        }, 500);
      }
      this.searchTableWaiting = true;
    },
    "productsTypes.search": function(value) {
      this.preLoadGenericSearchEntity(
        value,
        this.productsTypes,
        CONTEXT_PRODUCTS_TYPES
      );
    },
    "languages.search": function(value) {
      this.preLoadGenericSearchEntity(value, this.languages, CONTEXT_LANGUAGES);
    },
    "productsTypesFilter.search": function(value) {
      this.preLoadGenericSearchEntity(
        value,
        this.productsTypesFilter,
        CONTEXT_PRODUCTS_TYPES
      );
    }
  },
  methods: {
    search() {
      console.debug("Search elements");

      // Items have already been requested
      if (this.loading) return;

      this.loading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.filter.sortBy = sortBy;
      this.filter.sortDesc = sortDesc;
      this.filter.page = page;
      this.filter.itemsPerPage = itemsPerPage;

      localhttp
        .post(CONTEXT + "/allPagination/" + this.filter.page, this.filter)
        .then(response => {
          this.pagination.totalItems = response.data.totalElements;
          this.items = response.data.content;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    preLoadGenericSearchEntity(value, object, context, aditionalFilter) {
      if (!object.isLoadingWaiting) {
        setTimeout(() => {
          this.genericSearchEntity(object, context, aditionalFilter);
          object.isLoadingWaiting = false;
        }, 500);
      }
      object.value = value;
      object.isLoadingWaiting = true;
    },
    async genericSearchEntity(object, context, aditionalFilter) {
      console.debug("genericSearchEntity");
      if (!object.isEdit || object.value === null || object.value === "")
        return;

      if (object.isLoading) return;

      object.isLoading = true;

      let filterGeneric = {
        allFields: object.value
      };
      if (aditionalFilter !== undefined) {
        Object.keys(aditionalFilter).forEach(
          key => (filterGeneric[key] = aditionalFilter[key])
        );
      }

      // Lazily load input items
      localhttp
        .post(context + "/allFilter", filterGeneric)
        .then(response => {
          console.debug(response.data);
          object.entries = response.data;
        })
        .catch(e => {
          console.log(e);
          this.$showError();
        })
        .finally(() => (object.isLoading = false));
    },
    create() {
      console.debug("Create element");
      this.editMode = false;
      this.resetDialog();
      this.dialog = true;
    },
    async save() {
      console.debug("Save form");
      this.item.productTypeCode = this.productType;
      localhttp
        .post(CONTEXT + "/create", this.item)
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    edit(id) {
      console.debug("Edit element " + id);
      this.editMode = true;
      this.resetDialog();
      localhttp
        .get(CONTEXT + "/" + id)
        .then(response => {
          this.item = response.data;
          this.dialog = true;
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    async update() {
      console.debug("Update form");
      localhttp
        .put(
          CONTEXT +
            "/update/" +
            this.item.languageCode +
            "/" +
            this.item.productTypeCode,
          this.item
        )
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    async suspend(id) {
      console.debug("Suspend element " + id);
      if (
        await this.$root.$confirm(
          this.$t("global.confirm"),
          this.$t("global.action.suspend.confirm"),
          { color: "blue" }
        )
      ) {
        localhttp
          .put(CONTEXT + "/delete/" + id)
          .then(response => {
            console.log(response.data);
            this.search();
          })
          .catch(e => {
            console.log(e);
            this.$showErrorCode(e.response.status);
          });
      }
    },
    refreshItemsView() {
      console.debug("Refresh table");
      this.search();
    },
    close() {
      this.dialog = false;
    },
    resetDialog() {
      this.item = {};
      this.resetProductsTypesSearch();
      requestAnimationFrame(() => {
        if (this.$refs.obs !== undefined) {
          this.$refs.obs.reset();
        }
      });
    },
    resetProductsTypesSearch() {
      this.productsTypessearch = "";
      this.productsTypesentries = [];
    },
    back() {
      this.$router.push({
        name: "productsTypes"
      });
    }
  },
  beforeMount() {
    this.filter.productType = this.$props.productType;
  }
};
</script>
